function less_clothing_and_accessory_items (plan_name,customer_subscription,no_of_membership_clothes,no_of_membership_accessories) {
  var less_clothing_items_count = (ALLOWED_PRODUCTS[customer_subscription]["clothing"] - no_of_membership_clothes);
  var clothing_grammar = null;

  if (less_clothing_items_count == 1)
  {
    clothing_grammar = "With the " + plan_name + " plan you are allowed to get " + less_clothing_items_count + " more clothing item. Are you sure you want to checkout without an extra free clothing item?";
  }
  else if (less_clothing_items_count > 1)
  {
    clothing_grammar = "With the " + plan_name + " plan you are allowed to get " + less_clothing_items_count + " more clothing items. Are you sure you want to checkout without extra free clothing items?";
  }

  fancyconfirm(clothing_grammar, {
    buttons: [
      {
        class: "yes",
        type: "button",
        title: "Yes",
        value: "yes"
      }, {
        class: "no",
        type: "button",
        title: "No",
        value: "no"
      }
    ],
    modal: true
  },
               function (resp) {
    if(resp == "yes"){
      var less_accessory_items_count = (ALLOWED_PRODUCTS[customer_subscription]["accessories"] - no_of_membership_accessories);
      var accessory_grammar = null;

      if (less_accessory_items_count == 1)
      {
        accessory_grammar = "With the " + plan_name + " plan you are allowed to get " + less_accessory_items_count + " more accessory item. Are you sure you want to checkout without an extra free accessory item?";
      }
      else if (less_accessory_items_count > 1)
      {
        accessory_grammar = "With the " + plan_name + " plan you are allowed to get " + less_accessory_items_count + " more accessory items. Are you sure you want to checkout without extra free accessory items?";
      }

      fancyconfirm(accessory_grammar, {
        buttons: [
          {
            class: "yes",
            type: "button",
            title: "Yes",
            value: "yes"
          }, {
            class: "no",
            type: "button",
            title: "No",
            value: "no"
          }
        ],
        modal: true
      },
                   function (response) {
        if(response == "yes"){
          window.location.href = STORE_URL + "/checkout";
        }
      });
    }
  });
}